/**
 * Created by seaasun on 2017/11/24.
 */
import Vue from 'vue'
import utils from '@/assets/utils/index'

export default {
  namespaced: true,
  state: {
    init: {
      userPoint: false,
      recentOrder: false,
      saveOrder: false,
      userInfo: false
    },
    initUserInfo: false,
    userAddress: {
      AddrDesc: 'My Address',
      AddressType: 3,
      CityName: '',
      StateCode: '',
      ZipCode: '',
      AddressLine: '',
      AddressLine2: '',
      AddressName: '',
      CountryCode: '',
      Latitude: 0,
      longitude: 0,
      Userid: ''
    },
    userInfo: {
      AddrType: null,
      FirstName: '',
      LastName: '',
      Userid: null,
      Company: '',
      Name: '',
      UsersAddress: [
        {
          AddressType: 3,
          CityName: '',
          StateCode: '',
          ZipCode: '',
          AddressLine: ''
        }
      ],
      userAddress: {
        AddrDesc: '',
        AddressType: 3,
        CityName: '',
        StateCode: '',
        ZipCode: '',
        AddressLine: '',
        AddressLine2: '',
        AddressName: '',
        CountryCode: '',
        Latitude: 0,
        longitude: 0,
        Userid: ''
      },
      userHasAddress: false,
      Email: '',
      HomePhone: '',
      UserGuid: ''
    },
    ShowVideos: false,
    UserVideos: [],
    orderDetails: {},
    recentOrder: [],
    saveOrder: [],
    accountLists: [],
    recommendedOrder: [],
    userDataSources: [
      {
        ListType: 10,
        Desc: 'Consumer',
        Sequence: 1
      },
      {
        ListType: 170,
        Desc: 'Business',
        Sequence: 2
      }
    ],
    userAvatar: '',
    userPoint: 0,
    accountId: false,
    userPaymentCard: {
      HolderName: '',
      CardNumber: '',
      CardType: 10,
      CVV: '',
      ExpirationMonth: null,
      ExpirationYear: null,
      Address: '',
      City: '',
      State: '',
      ZipCode: '',
      CompanyName: ''
    },
    userServiceDataSources: {
      showEmailAppend: false,
      showEmailVerification: false,
      showCleanList: false,
      showEnhanceList: false,
      showPortraitReports: false,
      showPhoneAppend: false,
      showPhoneReverse: false,
      showEmailReverse: false,
      showPhoneVerification: false
    },

    dataSources: {
      '-9': 'Phone Reverse',
      '-8': 'Phone Verification',
      '-7': 'Phone Append',
      '-6': 'EnhanceList Bundle',
      '-5': 'Email Verification',
      '-4': 'Email Append',
      '-3': 'Portrait Reports',
      '-2': 'Enhance List',
      '-1': 'Clean List',
      10: 'Consumer',
      20: 'Business',
      30: 'New Homeowner',
      40: 'New Mover',
      50: 'Occupant',
      60: 'New Homeowner',
      70: 'Equifax',
      80: 'Experian',
      90: 'Compass',
      100: 'Canadian',
      110: 'InfoUSA',
      120: 'InfoUSA',
      130: 'Valassis',
      140: 'Resident',
      150: 'InfoUSA',
      160: 'InfoUSA',
      170: 'InfoBase',
      180: 'InfoUSA',
      190: 'Mobile Campaign',
      200: 'Customer',
      210: 'Business',
      270: 'Customer'
    }
  },
  getters: {
    userInfo: state => {
      state.userInfo.Name = state.userInfo.FirstName || ''
      if (state.userInfo.Name) {
        state.userInfo.Name += ' '
      }
      state.userInfo.Name += state.userInfo.LastName || ''
      return state.userInfo
    },
    isNewUI: state => {
      return state.userInfo.IsNewUI
    },
    accountList: state => {
      return state.accountLists
    },
    accountId: state => {
      return state.accountId
    }
  },
  mutations: {
    saveKey (state, val) {
      Vue.set(state, val[0], val[1])
    },
    saveUserInit (state, val) {
      state.accountLists = val.AccountList
      for (var i = 0; i < state.accountLists.length; i++) {
        var item = state.accountLists[i]
        if (item.IsDefault) {
          state.accountId = item.AccountId
        }
      }
      if (val.SavedCounts.length >= 2) {
        state.saveOrder = val.SavedCounts.slice(0, 2)
      } else {
        state.saveOrder = val.SavedCounts
      }
      state.init.saveOrder = true
      if (val.OrderHistories.length >= 2) {
        state.recentOrder = val.OrderHistories.slice(0, 2)
      } else {
        state.recentOrder = val.OrderHistories
      }
      state.init.recentOrder = true

      var point = val.UserPoint
      if (point > 0) {
        state.userPoint = point
      } else {
        state.userPoint = 0
      }
      state.init.userPoint = true
      state.recommendedOrder = val.RecommendOrders
    }
  },
  actions: {
    getUserPaymentCard ({commit}) {
      Vue.http.post('PlaceOrder.aspx/GetUserPaymentCards', {
        userId: 0
      })
        .then(resp => {
          if (resp.body.d.DataSource !== null) {
            commit('saveKey', ['userPaymentCard', resp.body.d.DataSource])
          }
        })
    },
    getUserInit ({commit}) {
      // Vue.http.post('LandingPage.aspx/Init', {})
      //   .then(resp => {
      //     commit('saveUserInit', resp.body.d.DataSource)
      //     let state = resp.body.d.DataSource
      //     for (let item of state.AccountList) {
      //       if (item.IsDefault) {
      //         commit('order/saveKey', ['AccountId', item.AccountId], { root: true })
      //       }
      //     }
      //   })
    },
    getEditUserInfo ({state, commit}) {
      // Vue.http.post('ba/EditProfile.aspx/GetInitEditProfileData', {}).then(resp => {
      //   commit('saveKey', ['initUserInfo', true])
      //   let user = resp.body.d.DataSource.UserDetails
      //   commit('saveKey', ['userInfo', user])
      //   utils.log('login', user.Userid, user.IsNewUI, window.location.toString())

      //   if (!user.IsNewUI && user.Userid !== 11781) {
      //     window.location = '../login.aspx'
      //   }

      //   let address = state.userInfo.UsersAddress
      //   let userAddress = false
      //   for (var i = 0; i < address.length; i++) {
      //     if (state.userInfo.AddrType === address[i].AddressType) {
      //       userAddress = address[i]
      //     }
      //   }
      //   if (userAddress !== false && utils.getUrlParam('address') !== 'true') {
      //     commit('saveKey', ['userAddress', userAddress])
      //     commit('saveKey', ['userHasAddress', true])
      //   } else {
      //     commit('saveKey', ['userAddress', {userAddress: {Userid: state.userInfo.Userid}}])
      //   }

      //   let showVideos = resp.body.d.DataSource.ShowVideos
      //   commit('saveKey', ['ShowVideos', showVideos])
      //   let userVideos = resp.body.d.DataSource.UserVideos
      //   commit('saveKey', ['UserVideos', userVideos])
      // })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js